module.exports = __webpack_public_path__ + "img/msi_x.c369658c.jpg";